<template>
  <ScreenSplitter>
    <DxItem v-model:collapsed="drawerCollapseStates.left"
            :collapsible="true"
            :size="230"
            :min-size="230"
            :max-size="230"
    >
      <AdminSettingsAccordion/>
    </DxItem>
    <DxItem>
      <div class="admin-settings-page">
        <router-view/>
      </div>
    </DxItem>
  </ScreenSplitter>
</template>

<script setup>
  import AdminSettingsAccordion from "@/components/admin-page/AdminSettingsAccordion.vue";
  import ScreenSplitter from "@/components/base-components/drawer/ScreenSplitter.vue";
  import { DxItem } from "devextreme-vue/splitter";
  import { storeToRefs } from "pinia";
  import { useHeaderStore } from "@/stores/headerStore.js";
  import { useAdminPageStore } from "@/stores/adminPageStore.js";

  const headerStore = useHeaderStore()
  const { drawerCollapseStates } = storeToRefs(headerStore)

  const adminPageStore = useAdminPageStore()
  adminPageStore.getFullUserList()
  adminPageStore.getInvitedUsers()
</script>

<style scoped lang="scss">
  .admin-settings-page {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  :deep(.dx-resize-handle) {
    cursor: default !important;
  }
</style>
